export default __webpack_public_path__ + "3f7a23bed910b28c82c7bd16118e2ce2.svg";